export enum BarcodePrefix {
  PACKAGE_CONTAINER = 'PC',
  PACKAGE_IDENTIFIER = 'PI'
}
